export default __webpack_public_path__ + "static/media/clearIconDark.6cb8880e.svg";